import { Airport, Flight } from '../types';

export const mockAirports: Airport[] = [
  { code: 'JFK', name: 'John F. Kennedy International Airport', city: 'New York' },
  { code: 'LAX', name: 'Los Angeles International Airport', city: 'Los Angeles' },
  { code: 'LHR', name: 'Heathrow Airport', city: 'London' },
  { code: 'CDG', name: 'Charles de Gaulle Airport', city: 'Paris' },
  { code: 'NRT', name: 'Narita International Airport', city: 'Tokyo' },
  { code: 'SIN', name: 'Singapore Changi Airport', city: 'Singapore' },
  { code: 'DXB', name: 'Dubai International Airport', city: 'Dubai' },
  { code: 'FRA', name: 'Frankfurt Airport', city: 'Frankfurt' },
  { code: 'SYD', name: 'Kingsford Smith Airport', city: 'Sydney' },
  { code: 'ORD', name: 'O\'Hare International Airport', city: 'Chicago' },
];

const airlines = [
  'Delta Air Lines',
  'American Airlines',
  'United Airlines',
  'British Airways',
  'Lufthansa',
  'Emirates',
];

export function generateMockFlights(from: string, to: string, date: string): Flight[] {
  const flights: Flight[] = [];

  for (let i = 0; i < 6; i++) {
    const airline = airlines[i % airlines.length];
    const flightNumber = `${airline.substring(0, 2).toUpperCase()}${Math.floor(Math.random() * 9000) + 1000}`;

    // Generate realistic departure and arrival times
    const baseHour = 6 + i * 3; // Spread flights throughout the day
    const departureTime = `${baseHour.toString().padStart(2, '0')}:${(Math.floor(Math.random() * 4) * 15).toString().padStart(2, '0')}`;

    // Random flight duration between 2-8 hours
    const durationHours = 2 + Math.floor(Math.random() * 6);
    const durationMinutes = Math.floor(Math.random() * 4) * 15;
    const duration = `${durationHours}h ${durationMinutes}m`;

    // Calculate arrival time
    const [depHour, depMin] = departureTime.split(':').map(Number);
    const totalMinutes = depHour * 60 + depMin + durationHours * 60 + durationMinutes;
    const arrHour = Math.floor(totalMinutes / 60) % 24;
    const arrMin = totalMinutes % 60;
    const arrivalTime = `${arrHour.toString().padStart(2, '0')}:${arrMin.toString().padStart(2, '0')}`;

    flights.push({
      id: `flight-${i + 1}`,
      airline,
      flightNumber,
      departure: {
        airport: from,
        time: departureTime,
      },
      arrival: {
        airport: to,
        time: arrivalTime,
      },
      duration,
      price: Math.floor(Math.random() * 800) + 200, // $200-$1000
    });
  }

  return flights;
}